import styled from 'styled-components';
import { theme } from '../../global';

export const CaseLinksContainer = styled.div`
  display: flex;
  gap: ${theme.spacings.s4};
  align-items: center;
  flex-wrap: wrap;
`;

export const Item = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;

export const Description = styled.span`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 14px;
  line-height: 17.07px;
  color: ${theme.colors.secondaryText};
  align-self: start;
`;
